import React from 'react';
import { Select } from '@paycor/picl/form-elements';
import style from './style.module.scss';

export default function SelectField(props) {
	const { id, displayOptions, onHandleChange, value } = props;
	const inputKey = Math.random();

	const selectedDisplayOption = (value && displayOptions && displayOptions.find((displayOption) => `${displayOption.value}` === `${value}`)) || null;

	return (
		<div className={style.select_container}>
			<Select key={inputKey.toString(36)} placeholder={'Select an option...'} id={id} options={displayOptions} onChange={onHandleChange} selected={selectedDisplayOption} />
		</div>
	);
}
